import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';
import * as fromPaymentCheck from '../../../screens/payment-check/state/payment-check.selectors';
import * as PaymentCheckAction from '../../../screens/payment-check/state/payment-check.actions';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { slideInDownAnimation } from 'src/app/app.animation';
import { AngularMaterialService } from 'src/commons';
@Component({
    selector: 'payment-check-ext-table-component',
    templateUrl: 'payment-check-ext-table-component.html',
    styleUrls: ['payment-check-ext-table-component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentCheckExtTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    @Input() data: any[];
    @Input() type: any;
    @Input() form: any;
    @Input() displayedColumns: any[];

    datePipe = new DatePipe('en-US');
    isAllChecked: boolean = false;
    isIndeterminate: boolean = false;
    localData: any[];

    public dataSource: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);
    // selectedRequests = [];

    constructor(
        private store: Store<fromPaymentCheck.State>,
        private router: Router,
        private ams: AngularMaterialService,
    ) { }

    public ngOnInit() {
        setTimeout(() => {
            this.localData = this.data;
            this.buildDataSource(this.localData);
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            setTimeout(() => {
                this.localData = changes['data'].currentValue;
                this.buildDataSource(this.localData);
            });
        }

    }

    buildDataSource(data: any) {
        const filter = this.dataSource !== undefined ? this.dataSource.filter : '';
        this.dataSource = new MatTableDataSource(data);

        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'orgInfoName': return item.orgInfoName.toLowerCase();
                case 'orgInfoSubsection': return isNaN(item.orgInfoSubsection) ? item.orgInfoSubsection : +item.orgInfoSubsection;
                case 'formName': return item.formName.toLowerCase();
                case 'requestNo': return +item.requestNo.substring(2);
                case 'status': return item.status.toLowerCase();
                case 'OeBSStatusCode': return item.FormCCOeBS.validateStatusCode.toLowerCase();
                case 'dateRequest': return new Date(item.dateRequest);
                default: return item[property];
            }
        };

        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'OrgInfo':
                        return currentTerm + data.orgInfoName + this.getTaxExemptStatus(data.orgInfoSubsection);
                    case 'FormCCLogInfo':
                        return currentTerm + data.FormCCLogInfo.empName
                            + data.FormCCLogInfo.title
                            + data.FormCCLogInfo.comment;
                    case 'effdt':
                        const newDate = this.datePipe.transform(data.effdt, 'MM-dd-yyyy');
                        return currentTerm + newDate.toString();
                    default:
                        return currentTerm + data[key];
                }
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };

        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.clearToggle();
    }

    onValidate() {
        this.ams.showConfirm('Are you sure you want to validate selected request(s)?', '');
        this.ams.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                switch (this.form) {
                    case 'CG':
                        this.store.dispatch(new PaymentCheckAction.ValidateFormCG(this.selection.selected))
                        break;
                    case 'PP':
                        this.store.dispatch(new PaymentCheckAction.ValidateFormPP(this.selection.selected))
                        break;
                    case 'ES':
                        this.store.dispatch(new PaymentCheckAction.ValidateFormES(this.selection.selected))
                        break;
                    // case 'CI':
                    //     this.store.dispatch(new PaymentCheckAction.ValidateFormCI(this.selection.selected))
                    //     break;
                }
            }
        });
    }

    uploadToOeBS() {
        this.ams.showConfirm('Are you sure you want to send selected request(s) to OeBS?', '');
        this.ams.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                switch (this.form) {
                    case 'CG':
                        this.store.dispatch(new PaymentCheckAction.SendToOeBSFormCG(this.selection.selected))
                        break;
                    case 'PP':
                        this.store.dispatch(new PaymentCheckAction.SendToOeBSFormPP(this.selection.selected))
                        break;
                    case 'ES':
                        this.store.dispatch(new PaymentCheckAction.SendToOeBSFormES(this.selection.selected))
                        break;
                    // case 'CI':
                    //     this.store.dispatch(new PaymentCheckAction.SendToOeBSFormCI(this.selection.selected))
                    //     break;
                }
            }
        });
    }

    generateCR() {
        switch (this.form) {
            case 'CG':
                this.store.dispatch(new PaymentCheckAction.LoadFormCGForControlReportState());
                break;
            case 'PP':
                this.store.dispatch(new PaymentCheckAction.LoadFormPPForControlReportState());
                break;
            case 'ES':
                this.store.dispatch(new PaymentCheckAction.LoadFormESForControlReportState());
                break;
            // case 'CI':
            //     this.store.dispatch(new PaymentCheckAction.LoadFormCIForControlReportState());
            //     break;
        }
    }

    isAllSelected() {
        let isAll = false;

        isAll = this.data.length === this.selection.selected.length

        this.isAllChecked = this.selection.hasValue() && isAll;
        this.isIndeterminate = this.selection.hasValue() && !isAll;
    }

    masterToggle(event) {
        if (this.isAllChecked) {
            this.clearToggle();
        } else {
            this.dataSource.filteredData.forEach(row => this.selection.select(row));
        }
        this.isAllSelected();
    }

    formDataChecked(row) {
        this.selection.toggle(row);
        this.isAllSelected();
    }

    clearToggle() {
        this.selection.clear();
        this.isAllSelected();
    }

    public getStatusClass(status): string {
        const possibleStatus = ['Submitted', 'Pending', 'Draft', 'Approved', 'PendingApproval', 'Rejected', 'INVALID', 'VALID', 'SUCCESSFUL', 'Sent To Oracle', 'Waiting For Oracle', 'Withdrawn', 'Paid Credit', 'Check Cashed', 'Check Issued', 'Check Voided'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public selectRow(row): void {
        switch (row.requestNo.substring(0, 2)) {
            case 'CG':
                this.router.navigate([`charity-forms/community-grant/${row.formId}`]);
                break;
            case 'PP':
                this.router.navigate([`charity-forms/plant-planet/${row.formId}`]);
                break;
            case 'ES':
                this.router.navigate([`charity-forms/event-sponsorship/${row.formId}`]);
                break;
            // case 'CI':
            //     this.router.navigate([`charity-forms/community-investment/${row.formId}`]);
            //     break;
            // case 'FO':
            //     this.router.navigate([`charity-forms/foundation/${row.formId}`]);
            //     break;
        }
    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

}
